import React, {useContext, useEffect, useState} from 'react';
import Ingredient from "../../model/menudesign/Ingredient";
import '../../styles/Commons.css';
import {Button, Card, Progress, Table, Tag, Popconfirm} from "antd";
import type {ColumnsType, TableProps} from 'antd/es/table';
import IngredientList from "./components/IngredientList";
import Colors from '../../styles/Colors';
import {BiPencil, BiPlus, BiRefresh, BiTrash} from "react-icons/bi";
import Historials from "../components/Historials";
import {BsEye} from "react-icons/bs";
import {GetIngredients} from "../../dao/menudesign/GetIngredients";
import {DeleteIngredient} from "../../dao/menudesign/DeleteIngredient";
import IngredientModal from "./components/IngredientModal";
import {AuthContext} from "../../config/AuthContext";
import {useNavigate, useParams} from "react-router-dom";
import Login from "../root/Login";
import NavBar from "../components/NavBar";
import toast, {Toaster} from "react-hot-toast";
import {QuestionCircleOutlined} from "@ant-design/icons";

const Ingredients = () => {

    const typeColors: { [key: string]: string } = {
        ou: 'magenta',
        pasta: 'lime',
        vegetal: 'orange',
        arròs: 'blue',
        cereal: 'cyan',
        especia: 'purple',
        condiment: 'gold',
        gra: 'volcano',
        verdura: 'green',
        tubercle: 'red',
        fruita: 'geekblue',
        lactic: 'cyan',
        peix: 'yellow',
        'carn vermella': 'pink',
        altres: 'default',
        hortalissa: 'brown',
        'carn blanca': 'white',
    };

    const {isLoggedIn, userId, user, page} = useContext(AuthContext);
    const navigate = useNavigate();
    const {id} = useParams();
    const [dades, setDades] = (useState<string>())

    const [ingredients, setIngredients] = useState<Ingredient[]>([]);
    const [ingredientSelected, setIngredientSelected] = useState<Ingredient>(new Ingredient());
    const [loading, setLoading] = useState(false);
    //const [nouIngredient, setNouIngredient] = useState(false);
    const [nouElement, setNouElement] = useState(false);
    const [visible, setVisible] = useState(true);
    const [nomFiltres, setNomFiltres] = useState<{ text: string; value: string }[]>([]);
    const [tipusFiltres, setTipusFiltres] = useState<{ text: string; value: string }[]>([]);
    const [editar, setEditar] = useState(false);
    const [elementSelected, setElementSelected] = useState<Ingredient>(new Ingredient());
    



    async function checkIngredients() {
        handleLoadingChange(true)
        const ingredients = await GetIngredients(page);
        await setIngredients(ingredients);
        await setNameFilters(ingredients);
        await setTipFiltres(ingredients);
        await handleLoadingChange(false);
    }

    useEffect(() => {
        if(isLoggedIn){
            handleLoadingChange(true)
            checkIngredients();
        }
    }, [id]);

    function setNameFilters(ingredients: Ingredient[]) {
        if (ingredients && ingredients.length > 0) {
            const ingredientNames = ingredients.map((ingredient) => ({
                text: ingredient.nom,
                value: ingredient.nom,
            }));
            setNomFiltres(ingredientNames);
        }
    }

    function setTipFiltres(ingredients: Ingredient[]) {
        if (ingredients && ingredients.length > 0) {
            const uniqueNames = new Set<string>();
            ingredients.forEach((ingredient) => uniqueNames.add(ingredient.tipus));

            const ingredientNames = Array.from(uniqueNames).map((name) => ({
                text: name,
                value: name,
            }));

            setTipusFiltres(ingredientNames);
        }
    }


    async function deleteIngredient(id: number) {
        await DeleteIngredient(userId, id, page);
        await checkIngredients();
    }
    function afegirElement(element: Ingredient) {
        setNouElement(!nouElement);
        setElementSelected(element);
    }

    function togleNouElement(ingredient: Ingredient,  edit: boolean) {
        setNouElement(!nouElement);
        setEditar(edit);
        setElementSelected(ingredient);
    }

     async function handleCloseModal(value: boolean) {
        if (value)
            toast.success("GUARDAT");
        else
            toast.error("NO GUARDAT");
        setNouElement(false);
        await checkIngredients();
    }
    function nouIngredient() {
        setEditar(true);
        afegirElement(new Ingredient());
    }

    const handleLoadingChange = (enable: boolean) => {
        setLoading(enable);
    };

    const columns: ColumnsType<Ingredient> = [
        {
            key: 'id',
            title: 'ID',
            dataIndex: 'id',
            width: 15,
            responsive: ['lg'],
            sorter: (a, b) => a.id - b.id,
            filterSearch: true,
            onFilter: (value, record) => (typeof value === 'string' ? record.id.toString().startsWith(value) : false),
        },
        {
            key: 'nom',
            title: 'Nom',
            dataIndex: 'nom',
            width: 30,
            filterSearch: true,
            filters: nomFiltres,
            onFilter: (value, record) => (typeof value === 'string' ? record.nom.startsWith(value) : false),
        },
        {
            key: 'tipus',
            title: 'Tipus',
            dataIndex: 'tipus',
            width: 30,
            filterSearch: true,
            filters: tipusFiltres,
            onFilter: (value, record) => (typeof value === 'string' ? record.tipus.startsWith(value) : false),
            render: (name: string) => (
                <Tag color={typeColors[name]}>
                    {name}
                </Tag>
            ),
        },
        {
            key: 'mesura', title: 'Unitat mesura', dataIndex: 'mesura', width: 25,
            responsive: ['md'],
            filterSearch: true,
            //sorter: (a, b) => a.mesura - b.estat,
            /* render: (estat: number) => (
                <Progress showInfo={false} percent={(estat / 4) * 100} steps={4}
                          strokeColor={[Colors.colors.color6, Colors.colors.color4, Colors.colors.color3, Colors.colors.color1]}/>
            ), */
        },
        {
            key: 'accions', title: 'Accions', dataIndex: 'accions', width: 30,
            render: (estat, ing) => (
                <>
                    <Button title={"Editar"} style={{backgroundColor: Colors.colors.color6}}
                            onClick={() => togleNouElement(ing, true)}><BiPencil/></Button>
                    {" "}
                    <Popconfirm
                        title="Eliminant"
                        description="Vols eliminar definitivament aquest element?"
                        onConfirm={() => deleteIngredient(ing.id)}
                        icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
                            >
                                <Button title={"Eliminar"} style={{backgroundColor: Colors.colors.color5}}><BiTrash/></Button>
                    </Popconfirm>
                    {" "}
                    <Button title={"Mostrar"} style={{backgroundColor: Colors.colors.color4}} 
                    onClick={() => togleNouElement(ing, false)}><BsEye/></Button>
                </>
            ),
        },
    ];

    const tableProps: TableProps<Ingredient> = {
        loading
    };

    
    const onChange: TableProps<Ingredient>['onChange'] =
        (pagination,
         filters,
         sorter,
         extra) => {
            console.log('params', pagination, filters, sorter, extra);
        };

    const expandedRowRender2 = (ing: Ingredient) => {
        return (
            <IngredientList ingredient={ing}/>
        );
    };

    function toggleTable() {
        setVisible(!visible);
    }

    
   

    if (isLoggedIn) {
        return (
            <div>
                <Toaster/>
                <NavBar/>
                <div className={"general"}>
                    <Card bordered={true} className={"elemento"}>
                        <div className={"actionButtons"}>
                            <Button title={"Crear"} style={{backgroundColor: Colors.colors.color2}}
                                    onClick={() => nouIngredient()}><BiPlus/></Button>
                            <Button title={"Refrescar"} style={{backgroundColor: Colors.colors.color4}}
                                    onClick={() => checkIngredients()}><BiRefresh/></Button>
                        </div>
                        <h4 className={"titol"} onClick={toggleTable}>Ingredients</h4>
                        {visible && (
                            <Table
                                {...tableProps}
                                onChange={onChange}
                                columns={columns}
                                expandable={{
                                    expandedRowRender: (record) =>
                                        expandedRowRender2(record),
                                    rowExpandable: (record) => true,

                                }}
                                dataSource={ingredients}
                            />
                        )}
                    </Card>
                    <br/>
                    <Historials pantalla={"ingredients"} pagina={page}/>
                    {nouElement && (
                        <IngredientModal ingredient={elementSelected} onClose={handleCloseModal}
                                         visible={nouElement} editar={editar} page={page}/>
                    )}
                </div>
            </div>
        );
    } else {
        return (
            <Login/>
        );
    }
};

export default Ingredients;
